import React from "react";
import logo from "../../assets/images/logo.png";
import "./D_two.css";
function D_two() {
  return (
    <div className="d_two">
      <div className="container">
        <img src={logo} alt="" />
        <h4>
          {/* <span className="copywrite"><FaRegCopyright /></span>  */}
          2024 BUYERS GALAXY. ALL RIGHTS RESERVED
        </h4>
        <h4 className="h4">Privacy Policy | Trems and Condition</h4>
        <p>
          *At Buyers Galaxy, we're dedicated to maintaining the highest
          standards of privacy and integrity, in strict adherence to the
          Australian Communications and Media Authority (ACMA) guidelines and
          Australia's Privacy Principles. By submitting your details on our
          website, you're agreeing to let us use this information to send you
          tailored marketing communications via email and SMS. We promise to
          keep your data safe and confidential and we will never share or sell
          your data to third parties without your explicit consent. Your privacy
          is of utmost importance to us. We use your information solely to
          provide you with relevant and personalised updates about our products
          and services.
        </p>
        <p>
          You have complete control over our communications and can opt-out
          anytime, no questions asked. Each message we send includes the option
          to unsubscribe, ensuring you only receive content that is meaningful
          to you. Alternatively, email us at info@BuyersGalaxy.com.au and we
          will opt you out. We understand the importance of security in the
          digital age and have implemented robust measures to protect your
          personal information from unauthorised access, disclosure, alteration,
          or destruction. Our practices are designed to comply with all relevant
          regulations, reflecting our commitment to meet the standards set by
          the ACMA and uphold your trust in us. Your feedback is invaluable to
          us, and we encourage you to reach out with any concerns, suggestions,
          or questions. Our goal is to address your issues promptly and to your
          satisfaction, continually improving our service based on your input.
          In choosing Buyers Galaxy , you're not just selecting a service;
          you're partnering with a company that values your privacy as much as
          you do.
        </p>
      </div>
    </div>
  );
}
export default D_two;
